import initBsnValidator from "./bsnvalidator";
import initCompareToValidator from "./comparetovalidator";
import initDateValidator from "./date";
import initDateAtLeastXDaysInTheFuture from "./dateatleastxdaysinthefuture";
import initDateOnDayOfTheMonthValidator from "./dateondayofthemonthvalidator";
import initIbanValidator from "./ibanvalidator";
import initMustBeTrueIfValidator from "./mustbetrueifvalidator";
import initMustBeTrueValidator from "./mustbetruevalidator";
import initNumericValidator from "./numericvalidator";
import initRangedValidator from "./rangedvalidator";
import initRelativeDateRangeValidator from "./relativedaterangevalidator";
import initRequiredIfValidator from "./requiredifvalidator";
import initGroupRequiredValidator from "./grouprequiredvalidator";

export const initValidationRules = () => {
    initBsnValidator();
    initCompareToValidator();
    initDateValidator();
    initDateAtLeastXDaysInTheFuture();
    initDateOnDayOfTheMonthValidator();
    initDateOnDayOfTheMonthValidator();
    initIbanValidator();
    initMustBeTrueIfValidator();
    initMustBeTrueValidator();
    initNumericValidator();
    initRangedValidator();
    initRelativeDateRangeValidator();
    initRequiredIfValidator();
    initRelativeDateRangeValidator();
    initGroupRequiredValidator();
}